import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils';

export const inputClassName =
  'flex h-9 w-full min-w-0 rounded-md border border-border-strong bg-surface-raised px-3 py-1 text-fg text-sm shadow-xs transition-colors outline-none ' +
  'placeholder:text-fg-muted focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 ' +
  'disabled:cursor-not-allowed disabled:bg-surface-sunken disabled:opacity-70 read-only:bg-surface-sunken ' +
  'aria-invalid:border-danger aria-invalid:ring-danger/20 file:border-0 file:bg-transparent file:font-medium file:text-sm';

export function Input({ className, type = 'text', ...props }: ComponentProps<'input'>) {
  return (
    <input type={type} data-slot="input" className={cn(inputClassName, className)} {...props} />
  );
}
